import './bglines.css'
function Custombg() {
    return (
      <div>
        <div className='diagonalboxtop'/>
        <div className='diagonalbox'/>
      </div>
    );
  }
  
  export default Custombg;